import { render, staticRenderFns } from "./MatchStandingsComponent.vue?vue&type=template&id=1c6eb3bc&scoped=true&"
import script from "./MatchStandingsComponent.vue?vue&type=script&lang=js&"
export * from "./MatchStandingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./MatchStandingsComponent.vue?vue&type=style&index=0&id=1c6eb3bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6eb3bc",
  null
  
)

export default component.exports